import styled from '@emotion/styled';

const Container = styled.div`
  padding: 0 1rem;
  max-width: 100vw;
  width: 1800px;
`;

export default Container;
